'use strict';

import CreateUserController from './create-user.controller';
import EditUserController from './edit-user.controller';

export default class AdminController {
  user;
  users: Object[];
  $mdDialog;

  /*@ngInject*/
  constructor($mdDialog, User) {
    // Use the User $resource to fetch all users
    this.user = User;
    this.$mdDialog = $mdDialog;
    this.users = User.query();
    this.selected = [];
  }

  deleteUser(user) {
    user.$remove();
    this.users.splice(this.users.indexOf(user), 1);
  }

  createNewUser = (ev) => {
    this.$mdDialog.show({
      controller: CreateUserController,
      template: require('./create-user.dialog.html'),
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true
    })
      .then((result) => {
        this.users = this.user.query();
      }, () => {

      });
  };

  editUser = (ev, user) => {
    this.$mdDialog.show({
      controller: EditUserController,
      template: require('./edit-user.dialog.html'),
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true,
      locals: {
        user
      }
    })
      .then((result) => {
        this.users = this.user.query();
      }, () => {

      });
  };

  deleteSelectedUser = (ev) => {
    if(this.selected.length <= 0)
      return;

    const user = this.selected[0];

    if(user.role === 'admin')
      return;

    const confirm = this.$mdDialog.confirm()
      .title('Benutzer löschen?')
      .textContent(`Soll der Benutzer ${user.name} wirklich gelöscht werden?`)
      .ariaLabel('Löschen?')
      .targetEvent(ev)
      .ok('Ja')
      .cancel('Nein');

    this.$mdDialog.show(confirm).then(() => {
      user.$remove();
      this.users = this.user.query();
      this.selected = [];
    }, () => {
      this.users = this.user.query();
      this.selected = [];
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin.controller.js